<template>
  <el-config-provider :locale="locale" :size="assemblySize" :button="buttonConfig">
    <router-view v-if="showRouter"></router-view>
  </el-config-provider>
</template>

<script setup lang="ts">
import { onMounted, reactive, computed, ref, nextTick, provide } from "vue";
import { useI18n } from "vue-i18n";
import { getBrowserLang } from "@/utils";
import { useTheme } from "@/hooks/useTheme";
import { ElConfigProvider } from "element-plus";
import { LanguageType } from "./stores/interface";
import { useGlobalStore } from "@/stores/modules/global";
import en from "element-plus/es/locale/lang/en";
import zhCn from "element-plus/es/locale/lang/zh-cn";
import plusEn from "plus-pro-components/es/locale/lang/en";
import plusZhCn from "plus-pro-components/es/locale/lang/zh-cn";
import { resetRouter } from "@/typings";

const globalStore = useGlobalStore();
//刷新路由
const showRouter = ref(true);
const reLoad = () => {
  showRouter.value = false;
  nextTick(() => {
    showRouter.value = true;
  });
};
provide(resetRouter, reLoad);
// init theme
const { initTheme } = useTheme();
initTheme();

// init language
const i18n = useI18n();
onMounted(() => {
  const language = globalStore.language ?? getBrowserLang();

  i18n.locale.value = language;
  globalStore.setGlobalState("language", language as LanguageType);
});

// element language
const locale = computed(() => {
  if (globalStore.language == "zh")
    return {
      ...zhCn,
      ...plusZhCn
    };
  if (globalStore.language == "en")
    return {
      ...en,
      ...plusEn
    };
  if (getBrowserLang() == "zh") {
    return {
      ...zhCn,
      ...plusZhCn
    };
  } else {
    return {
      ...en,
      ...plusEn
    };
  }
});

// element assemblySize
const assemblySize = computed(() => globalStore.assemblySize);

// element button config
const buttonConfig = reactive({ autoInsertSpace: false });
</script>
